import { render, staticRenderFns } from "./DadoConteudo.vue?vue&type=template&id=bc1770f6&scoped=true"
import script from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
export * from "./DadoConteudo.vue?vue&type=script&setup=true&lang=js"
import style0 from "./DadoConteudo.vue?vue&type=style&index=0&id=bc1770f6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc1770f6",
  null
  
)

export default component.exports